// WW-Energie ValidationRules
import * as Yup from "yup";

export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;
export const characterRestrictionInDocNamesRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,_\-()]+$/i;
export const checkStateGrade = Yup.number()
.nullable().max(18, "Bitte geben Sie einen gültigen Wert an").min(1, "Bitte geben Sie einen gültigen Wert an")
.test("Length", "Es sind nur 2 Nachkommastellen erlaubt", val => {
    if (val) return val.toString().length <= 5;
    return true;
})

export const checkGrade = Yup.number()
.nullable().max(6, "Bitte geben Sie einen gültigen Wert an").min(1, "Bitte geben Sie einen gültigen Wert an")
.test("Length", "Es ist nur 1 Nachkommastelle erlaubt", val => {
    if (val) return val.toString().length <= 3;
    return true;
})

export const checkText = (settings) => Yup.string()
    .when("settings.isUnicode", {
        is: () => !settings.isUnicode,
        then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
    });
export const checkRequiredText = (settings) => Yup.string()
    .required("Angabe ist erforderlich")
    .when("settings.isUnicode", {
        is: () => !settings.isUnicode,
        then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
    });